export default __webpack_public_path__ + "static/media/logo.c612906e.png";